import { RootState } from '@/store';
import { CancelledOrdersState, CANCELLED_ORDERS_SLICE_NAME } from './models';

export const cancelledOrdersSelector = (state: RootState): CancelledOrdersState => state[CANCELLED_ORDERS_SLICE_NAME];
